import React from "react";

const Icon = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <g id="blob-1">
        <path d="M -20,-30 C -60,-30 -70,20 -40,50 C -10,70 50,60 70,30 C 85,5 50,-10 30,-5 C 10,0 0,-30 -20,-30 Z"></path>
      </g>
      <g id="blob-2">
        <path d="M -25,-25 C -65,-25 -70,25 -35,55 C -5,75 40,55 60,25 C 75,-5 45,-5 25,0 C 5,5 -5,-25 -25,-25 Z"></path>
      </g>
      <g id="blob-3">
        <path d="M -15,-35 C -55,-40 -80,10 -50,40 C -20,70 60,70 80,40 C 95,10 50,-15 30,-5 C 10,5 5,-30 -15,-35 Z"></path>
      </g>

      <symbol id="ic-chat" viewBox="0 0 32 32">
        <path
          d="M6 8 h16 a3 3 0 0 1 3 3 v8 a3 3 0 0 1 -3 3 h-9 l-5 4 v-4 h-2 a3 3 0 0 1 -3 -3 v-8 a3 3 0 0 1 3 -3 z"
          fill="#F5B041"
          fillOpacity=".18"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <circle cx="11" cy="15" r="1.5" fill="#C4841D"></circle>
        <circle cx="16" cy="15" r="1.5" fill="#C4841D"></circle>
        <circle cx="21" cy="15" r="1.5" fill="#C4841D"></circle>
      </symbol>

      <symbol id="ic-sparkle" viewBox="0 0 32 32">
        <path
          d="M16 4 L17.8 12.2 L26 14 L17.8 15.8 L16 24 L14.2 15.8 L6 14 L14.2 12.2 Z"
          fill="#F5B041"
          fillOpacity=".25"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinejoin="round"
        ></path>
        <path
          d="M24 22 L24.6 24.4 L27 25 L24.6 25.6 L24 28 L23.4 25.6 L21 25 L23.4 24.4 Z"
          fill="#C4841D"
        ></path>
        <path
          d="M7 5 L7.5 6.8 L9.3 7.3 L7.5 7.8 L7 9.6 L6.5 7.8 L4.7 7.3 L6.5 6.8 Z"
          fill="#C4841D"
        ></path>
      </symbol>

      <symbol id="ic-books" viewBox="0 0 32 32">
        <rect
          x="5"
          y="9"
          width="6"
          height="18"
          rx="1"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinejoin="round"
        ></rect>
        <line
          x1="5"
          y1="13"
          x2="11"
          y2="13"
          stroke="#C4841D"
          strokeWidth="1.5"
        ></line>
        <rect
          x="13"
          y="6"
          width="6"
          height="21"
          rx="1"
          fill="#F5B041"
          fillOpacity=".18"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinejoin="round"
        ></rect>
        <line
          x1="13"
          y1="11"
          x2="19"
          y2="11"
          stroke="#C4841D"
          strokeWidth="1.5"
        ></line>
        <line
          x1="13"
          y1="22"
          x2="19"
          y2="22"
          stroke="#C4841D"
          strokeWidth="1.5"
        ></line>
        <path
          d="M21.5 10 L27 11.4 L24.4 26 L18.9 24.6 Z"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinejoin="round"
        ></path>
        <line
          x1="20.6"
          y1="14.6"
          x2="25.6"
          y2="15.9"
          stroke="#C4841D"
          strokeWidth="1.4"
        ></line>
      </symbol>

      <symbol id="ic-flame" viewBox="0 0 32 32">
        <path
          d="M16 4 C 13 9 9 11 9 17 a 7 7 0 0 0 14 0 c 0 -3 -2 -5 -3 -7 -1 2 -2 3 -3 3 0 -3 0 -6 -1 -9 z"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <path
          d="M16 14 C 14.5 16 13 17.5 13 19.5 a 3 3 0 0 0 6 0 c 0 -2 -1.5 -3.5 -3 -5.5 z"
          fill="#C4841D"
          fillOpacity=".5"
        ></path>
      </symbol>

      <symbol id="ic-scroll" viewBox="0 0 32 32">
        <path
          d="M7 6 h16 a3 3 0 0 1 3 3 v17 a2 2 0 0 1 -2 2 H9 a3 3 0 0 1 -3 -3 V8 a2 2 0 0 1 1 -2 z"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <path
          d="M6 6 a2 2 0 0 0 -2 2 v3 a1 1 0 0 0 1 1 h3"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        ></path>
        <line
          x1="11"
          y1="13"
          x2="22"
          y2="13"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></line>
        <line
          x1="11"
          y1="18"
          x2="22"
          y2="18"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></line>
        <line
          x1="11"
          y1="23"
          x2="18"
          y2="23"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></line>
      </symbol>

      <symbol id="ic-coffee" viewBox="0 0 32 32">
        <path
          d="M7 13 H23 V21 a5 5 0 0 1 -5 5 H12 a5 5 0 0 1 -5 -5 z"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <line
          x1="5"
          y1="29"
          x2="25"
          y2="29"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinecap="round"
        ></line>
        <path
          d="M23 15 h2 a3.5 3.5 0 0 1 0 7 h-2"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <path
          d="M11 9 q1.4 -2 0 -4"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>
        <path
          d="M15 9 q1.4 -2 0 -4"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>
        <path
          d="M19 9 q1.4 -2 0 -4"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>
      </symbol>

      <symbol id="ic-42logo" viewBox="0 0 200 200">
        <path
          fill="#2E2437"
          d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z"
        ></path>
        <path
          fill="#2E2437"
          d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z"
        ></path>
        <path
          fill="#fff"
          d="M70.59,137.36H84.13v-9.25h7.62V116.46H84.13V78.51h-11l-26.3,41.12v8.48H70.59Zm-9-20.13,10.11-16.79v16.79Z"
        ></path>
        <path
          fill="#fff"
          d="M115.8,124.85v-.17l9.16-9.51c7.8-8.13,9.51-13.19,9.51-19.87,0-11-8.91-17.56-19-17.56s-16.53,5.05-20,11.13L105.26,96c2.57-3.77,5.57-5.48,9.08-5.48a6.08,6.08,0,0,1,6.17,6.34c0,4.2-2.66,7.88-7.28,12.77l-17.4,18.76.18,9h39.06V124.85Z"
        ></path>
      </symbol>

      <symbol id="ic-shield" viewBox="0 0 32 32">
        <path
          d="M16 4 L26 7 V15 c0 6 -4 11 -10 13 -6 -2 -10 -7 -10 -13 V7 z"
          fill="#F5B041"
          fillOpacity=".22"
          stroke="#C4841D"
          strokeWidth="2.2"
          strokeLinejoin="round"
        ></path>
        <circle cx="13" cy="14" r="1.4" fill="#C4841D"></circle>
        <circle cx="19" cy="14" r="1.4" fill="#C4841D"></circle>
        <path
          d="M11.5 18.5 c 1.5 2 3 3 4.5 3 s 3 -1 4.5 -3"
          fill="none"
          stroke="#C4841D"
          strokeWidth="2"
          strokeLinecap="round"
        ></path>
      </symbol>
    </defs>
  </svg>
);

export default Icon;
